<!-- Реквизиты оплаты расхода и inline-создание источника оплаты. -->
<template>
  <BaseFormSection title="Оплата" icon="payment">
    <BaseFormField
      label="Источник оплаты"
      for-id="payment_source"
      :filled="isFieldFilled('payment_source_id')"
    >
      <PaymentSourceSelect
        id="payment_source"
        :model-value="expense.payment_source_id"
        :with-button="true"
        button-label="Создать источник оплаты"
        @button-click="$emit('toggle-inline-payment-source-form')"
        @update:model-value="
          handleFieldChange('payment_source_id', $event)
        "
      />
    </BaseFormField>

    <BaseFormField
      label="Контрагент"
      for-id="counterparty"
      :filled="isFieldFilled('counterparty_id')"
    >
      <CounterpartySelect
        id="counterparty"
        :model-value="expense.counterparty_id"
        @update:model-value="handleFieldChange('counterparty_id', $event)"
      />
    </BaseFormField>

    <transition name="fade-slide">
      <div
        v-if="showInlinePaymentSourceForm"
        class="inline-nested-form form-layout__field form-layout__field--wide"
      >
        <div class="inline-form-header">
          <span class="inline-form-title">
            Новый источник оплаты
          </span>
          <button
            class="inline-form-close"
            type="button"
            aria-label="Закрыть"
            @click="$emit('close-inline-payment-source-form')"
          >
            <AppIcon name="close" :size="14" />
          </button>
        </div>
        <form @submit.prevent>
          <PaymentSourceForm
            :is-loading="isPaymentSourceCreating"
            submit-label="Создать и выбрать"
            @save="$emit('save-inline-payment-source', $event)"
            @cancel="$emit('close-inline-payment-source-form')"
          />
        </form>
      </div>
    </transition>
  </BaseFormSection>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import CounterpartySelect from "@/components/Counterparty/CounterpartySelect.vue";
import PaymentSourceForm from "@/components/Expense/PaymentSourceForm.vue";
import PaymentSourceSelect from "@/components/Expense/PaymentSourceSelect.vue";

export default {
  name: "ExpensePaymentSection",

  components: {
    AppIcon,
    CounterpartySelect,
    PaymentSourceForm,
    PaymentSourceSelect,
  },

  props: {
    expense: { type: Object, required: true },
    isPaymentSourceCreating: { type: Boolean, required: true },
    showInlinePaymentSourceForm: { type: Boolean, required: true },
  },

  emits: [
    "close-inline-payment-source-form",
    "save-inline-payment-source",
    "toggle-inline-payment-source-form",
    "update-field",
  ],

  methods: {
    handleFieldChange(field, value) {
      this.$emit("update-field", field, value);
    },

    isFieldFilled(field) {
      const value = this.expense[field];
      return value !== null && value !== undefined && value !== "";
    },
  },
};
</script>

<style scoped>
.inline-nested-form {
  border-radius: 8px;
  padding: 12px;
  margin-bottom: var(--base-in-indent);
  border: 2px dashed #b6b5b5;
  background: #eff6ff;
}

.inline-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.inline-form-title {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
}

.inline-form-close {
  background: none;
  border: none;
  font-size: 14px;
  color: #9ca3af;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.inline-form-close:hover {
  color: #374151;
}
</style>
